import React from "react";
import { render } from "react-dom";
import moment from "moment";
import { isBrowser } from 'react-device-detect';
moment().format();


export class Title extends React.Component<any, any> {
    render(): React.ReactNode {
        return (
            <div>
                <h3>Huppa Mykhailo - BackEnd Developer</h3>
            </div>
        )
    }
}



export class Divider extends React.Component<any, any> {
    render(): React.ReactNode {
        return (
            <div className="divider-container">
                <div className="divider-border" />
                <div className="divider-border" />
            </div>
        );
    }
}


class SectionTitle extends React.Component<any, any> {
    constructor(props: any) {
        super(props)
    }

    render(): React.ReactNode {
        return (
            <div>
                <h4 className="info">{this.props.text}</h4>
                <Divider/>
            </div>
        )
    }
}


function calculateAge(birthday: number[]) {
    return moment().diff(birthday, 'years').toString()
}


class InfoText extends React.Component<any, any> {
    constructor(props: any) {
        super(props)
    }

    render(): React.ReactNode {
        return (
            <p className="info">{this.props.text}</p>
        )
    }
}


export class AboutMe extends React.Component<any, any> {
    render(): React.ReactNode {
        return (
            <div style={{width: isBrowser ? "35%" : "70%"}}>
                <SectionTitle text="Some information about me" />
                <div>
                    <InfoText text={`I am ${calculateAge([2005, 10, 25])} y.o.`} />
                    <InfoText text="I was born in Ukraine, Mykolaiv 🇺🇦" />
                    <InfoText text="Now I live in Germany 🇩🇪" />
                    <InfoText text="I know Ukrainian, English and Russian languages" />
                </div>
                <Divider/>
            </div>
        )
    }
}


